const EventCancelAttendees = {
  initialize(cancellation_path) {
    this.cancellation_path = cancellation_path
    $("#events_cancel_attendees").on("click", () => {
      return alertModal(
        {
          title: "Cancel all registrations?",
          text:
            "Any payments will not be automatically refunded. Depending on the number of registrations, it may take a few minutes for all cancelations to take effect.",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "No, don't cancel them",
          confirmButtonText: "Yes, cancel all of them!",
          customClass: "destructive-warning",
          closeOnConfirm: true
        },
        () => {
          return $.ajax({
            method: "POST",
            url: this.cancellation_path,
            headers: { "X-CSRF-Token": $.rails.csrfToken() },
            success() {
              return alertModal({
                title: "Canceling!",
                text:
                  "We are in the process of canceling all the registrations for this signup. This may take a few minutes.",
                type: "success",
                confirmButtonText: "Ok"
              })
            }
          })
        }
      )
    })
  }
}

export default EventCancelAttendees
